<template lang="pug">
.v-payment.payment(v-if="data")
	.payment__row(v-if="data.items && data.items.length")
		a.payment__link.cover-link(v-if="data.link" :href="data.link")
		.payment__col(v-for="(item, idx) in data.items" :key="idx" :class="item.className ? item.className : ''" v-html="item.text")
</template>


<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {
	emits: [
		'action',
	],
	mixins: [
		sourceMixin,
	],
	data() {
		return {
			data: null,
		}
	},
	methods: {

		dataSet(data) {
			this.data = data;
			console.log(data)
		}
	},

}
</script>